import { useGetEnvVariablesQuery } from 'src/store/BaseApi';

export const useIsSpruce = (): boolean => {
  const { data } = useGetEnvVariablesQuery();
  return data?.brand === 'spruce';
};